// import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
// import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import LeadView from './LeadView';
// import SelectedContact from '../../contact/SelectedContact';
// import withPermission from '../../../utils/withPermission';
// import ActivityList from './activity/ActivityList';
// import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
// import { BiPencil } from "react-icons/bi";
// import { BsChevronLeft } from "react-icons/bs";
// import LeadModal from './LeadModal';
// import { FaRegClock, FaUserEdit, FaFileInvoice, FaTag, FaAddressCard } from "react-icons/fa";
// import moment from "moment";
// const LeadDetails = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const location = useLocation();
//     const queryParams = new URLSearchParams(location.search);
//     const initialTab = queryParams.get("activeTab") || "activityList";
//     const [leadDetails, setLeadDetails] = useState(null);
//     const [activeTab, setActiveTab] = useState('activityList');
//     const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
//     const WithActivityPermission = withPermission(({ children }) => children, ['activity-list']);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedLead, setSelectedLead] = useState(null);
//     const [timelineUpdates, setTimelineUpdates] = useState([]);
//     const [leads, setLead] = useState(null);
//     const [contacts, setContacts] = useState([]);
//     const [organisations, setOrganisation] = useState([]);


//     const didFetchRef = useRef(false);
//     const fetchTimelineUpdates = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Define params object
//             let params = {};

//             params.lead_id = id;

//             // Ensure that at least one valid param exists
//             if (!params.lead_id) {
//                 console.warn("Missing lead_id, skipping API call.");
//                 return;
//             }

//             const response = await axios.get(`${backendUrl}/api/history/all`, {
//                 headers: { Authorization: `Bearer ${token}`,                'Tenant-Origin': origin,
//             },
//                 params, // Pass query parameters
//             });

//             setTimelineUpdates(response.data.data);
//         } catch (error) {
//             console.error("Error fetching timeline updates:", error);
//         }
//     };
//     const fetchLeadDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/leads/${id}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });
//             console.log(response.data); // Check the data structure

//             setLeadDetails(response.data.Data); // Set the fetched data to state
//         } catch (error) {
//             console.error('Error fetching instance details:', error);
//         }
//     };
//     const fetchContacts = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;
//             const response = await axios.get(`${backendUrl}/api/contact`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//                 skipLoader: true,


//             });

//             const filteredContacts = response.data.Data.filter(
//                 contact => contact.type !== "instance" && contact.type !== "tenant"
//             );

//             setContacts(filteredContacts);

//         } catch (error) {
//             console.error('Error fetching contacts:', error);
//         }
//     };

//     const fetchOrganisation = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/organisation`, {
//                 headers: { Authorization: `Bearer ${token}`,
//                 'Tenant-Origin': origin,
//             },
//                 skipLoader: true,


//             });

//             const data = response.data.data;

//             setOrganisation(data);

//         } catch (error) {
//             console.error(`Error fetching :`, error);
//         }
//     };
//     const editLead = async (contactId, updatedData) => {
//         try {

//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Corrected API endpoint with dynamic contact_type for editing
//             const response = await axios.put(`${backendUrl}/api/leads/${contactId}`, updatedData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });
//             const updatedLead = response.data.Data;

//         if (updatedLead) {
//             // Update leadDetails state
//             setLeadDetails((prevLead) => ({
//                 ...prevLead,
//                 ...updatedLead, // Merge updated data
//             }));
//             setLead((prevOrganisations) =>
//                 prevOrganisations
//                     ? prevOrganisations.map((org) =>
//                         org.id === updatedLead.id ? updatedLead : org
//                     )
//                     : [updatedLead] // If null, set it as an array
//             );
//         } else {
//             console.error('Update failed, no data returned.');
//         }


//             setShowModal(false);
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors; // Return validation errors
//             } else
//                 console.error(`Error updating`, error);
//         }
//     };

//     useEffect(() => {
//         fetchLeadDetails();
//         // fetchTimelineUpdates();
//     }, [id]);

//     useEffect(() => {
//         const queryParams = new URLSearchParams(location.search);
//         const activeTabParam = queryParams.get("activeTab") || "activityList";
//         setActiveTab(activeTabParam);
//     }, [location.search]);

//     const handleBackClick = () => {
//         navigate(-1);
//     };

//     // Handle tab click to change active tab
//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//         navigate(`${location.pathname}?activeTab=${tab}`);

//     };
//     const getIcon = (action) => {
//         switch (action) {
//             case "Lead Created":
//                 return <FaRegClock className="icon created" />;
//             case "Lead Updated":
//                 return <FaUserEdit className="icon updated" />;
//             case "Contact Added":
//                 return <FaAddressCard className="icon invoice" />;
//             case "status":
//                 return <FaTag className="icon status" />;
//             default:
//                 return <FaRegClock className="icon default" />;
//         }
//     };
//     const groupByDate = (updates) => {
//         return updates.reduce((grouped, update) => {
//             const date = moment(update.created_at).format("MMM DD, YYYY");
//             if (!grouped[date]) {
//                 grouped[date] = [];
//             }
//             grouped[date].push(update);
//             return grouped;
//         }, {});
//     };
//     const groupedUpdates = groupByDate(timelineUpdates);
//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 {/* 🔹 Back Button & Title */}
//                                 <h4 className="mb-sm-0 d-flex align-items-center">
//                                     <BsChevronLeft
//                                         className='back-button1'
//                                         onClick={() => navigate(-1)}
//                                     />
//                                     <span>Lead</span>
//                                 </h4>
//                                 <div className="page-title-right br-font">
//                                     <ol className="breadcrumb m-0">
//                                         <li className="breadcrumb-item"><Link to={`/lead/details/${id}`}>
//                                             {leadDetails?.name || " Lead Details"}
//                                         </Link></li>
//                                         <li className="breadcrumb-item active">Details</li>
//                                     </ol>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="p-6 max-w-7xl mx-auto">
//                         <>
//                             <Card className="mb-4 shadow-lg rounded-3 p-2 border-0 card-bg">
//                                 {/* Header Section with Name and Edit Icon */}
//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <Card.Title className="fw-bold  font-size-14  text-primary">{leadDetails?.name}</Card.Title>
//                                     <BiPencil
//                                         className="text-primary hover-effect2 edit-pencil"
//                                         onClick={() => {
//                                             setSelectedLead(leadDetails); // Store organisation details
//                                             setShowModal(true); // Open modal
//                                         }} />
//                                 </div>
//                                 <Card.Body className="pt-3">
//                                     <div className="row">
//                                         {/* Left Section */}
//                                         <div className="col-md-6">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Organisation:</strong></span>
//                                                 <span className=" text-muted card-value">{leadDetails?.organisation?.name || '-'}</span>
//                                             </div>
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Lead Source:</strong></span>
//                                                 <span className=" text-muted card-value">{leadDetails?.lead_source || '-'}</span>
//                                             </div>
//                                         </div>

//                                         {/* Right Section */}
//                                         <div className="col-md-4">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block card-label"><strong>Notes:</strong></span>
//                                                 <span className="fw-semibold text-primary card-value">{leadDetails?.notes || ''}</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </Card.Body>
//                             </Card>
//                             {showModal && (
//                                 <LeadModal
//                                     showModal={showModal}
//                                     handleClose={() => setShowModal(false)}
//                                     leadData={selectedLead} // Pass data here
//                                     editLead={editLead}
//                                     fetchOrganisation={fetchOrganisation}
//                                     fetchContacts={fetchContacts}
//                                     contacts={contacts}
//                                     organisations={organisations}
//                                     leadId={id}
//                                 />
//                             )}

//                         </>
//                         <div className="row">
//                             <div className="col-xl-12 col-lg-8">
//                                 <div className="card">
//                                     {/* Nav tabs */}
//                                     <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2 font-size-13" role="tablist">
//                                        <WithActivityPermission>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'activityList' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('activityList')}
//                                                 role="tab"
//                                             >
//                                                 Activity
//                                             </a>
//                                         </li>
//                                         </WithActivityPermission>
//                                         <WithContactPermission>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('contactList')}
//                                                 role="tab"
//                                             >
//                                                 Contact
//                                             </a>
//                                         </li>
//                                         </WithContactPermission>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'leadDetails' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('leadDetails')}
//                                                 role="tab"
//                                             >
//                                                 Lead Details
//                                             </a>
//                                         </li>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'timeline' ? 'active' : ''}`}
//                                                 onClick={() => {
//                                                     setActiveTab('timeline');
//                                                     fetchTimelineUpdates(); // Fetch data only when clicking the Timeline tab
//                                                 }}                                                role="tab"
//                                             >
//                                                 Timeline
//                                             </a>
//                                         </li>
//                                     </ul>


//                                     {/* Tab panes */}
//                                     <div className="tab-content p-4">
//                                         {/* Contact List Tab */}
//                                         {activeTab === "contactList" && leadDetails && (
//                                             <div className="tab-pane active" id="contact-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                     <SelectedContact
//                                                         leadId={leadDetails?.id}
//                                                         entityType="lead"
//                                                         fetchLeadData={fetchLeadDetails} leadData={leadDetails} setLeadDetails={setLeadDetails}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         )}
//                                         {activeTab === "activityList" && leadDetails && (
//                                             <div className="tab-pane active" id="activity-list" role="tabpanel">
//                                                 <div className=" p-3">
//                                                     <ActivityList
//                                                         leadId={leadDetails?.id} type='lead'
//                                                         fetchLeadData={fetchLeadDetails} leadData={leadDetails} setLeadDetails={setLeadDetails}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         )}
//                                         {/* Organisation Details Tab */}
//                                         {activeTab === "leadDetails" && (
//                                             <div className="tab-pane active" id="lead-details" role="tabpanel">
//                                                 <div>
//                                                     {leadDetails ? (
//                                                         <LeadView data={leadDetails} leadId={id} setLeadDetails={setLeadDetails} />

//                                                     ) : (
//                                                         <p>Loading...</p>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         )}
//                                         {activeTab === "timeline" && leadDetails && timelineUpdates.length > 0 ? (
//                                             <div className="tab-pane active" id="timeline" role="tabpanel">
//                                                 <h4></h4><br />
//                                                 <div>
//                                                     <div>
//                                                     <div className="timeline">
//                                             {Object.entries(groupedUpdates ?? {})
//                                                 .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA)) // Sort dates descending (latest first)
//                                                 .map(([date, updates]) => (
//                                                     <div key={date} className="timeline-date-group">
//                                                         {/* Date Box */}
//                                                         <div className="timeline-date-box">{date}</div>

//                                                         {updates
//                                                             .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) // Sort updates descending (latest first)
//                                                             .map((update, index) => {
//                                                                 let title = update.action;
//                                                                 let details = null;

//                                                                 // Function to format field names
//                                                                 const formatFieldName = (field) => {
//                                                                     return field.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
//                                                                 };

//                                                                 // Handle different action types
//                                                                 if (update.history_type === "activity") {
//                                                                     if (update.action === "Meeting added" || update.action === "Task added" || update.action === "Call added") {
//                                                                         title = `${update.action} - ${update.data.subject}`;
//                                                                     } else if (update.action === "Meeting updated" || update.action === "Task updated" || update.action === "Call updated") {
//                                                                         title = `${update.action}`;
//                                                                         if (update.data.changes) {
//                                                                             details = Object.entries(update.data.changes)
//                                                                                 .filter(([key]) => !["created_at", "updated_at", "lead"].includes(key)) // Filter out unnecessary fields
//                                                                                 .map(([key, change]) => (
//                                                                                     <div key={key}>
//                                                                                         <strong>{formatFieldName(key)}</strong> changed from <strong>{change.old}</strong> to <strong>{change.new}</strong>
//                                                                                     </div>
//                                                                                 ));
//                                                                         }
//                                                                     }
//                                                                 } else if (update.history_type === "lead") {
//                                                                     if (update.action === "Lead Updated" && update.data.old && update.data.new) {
//                                                                         if (update.data.old.stage && update.data.new.stage && update.data.old.stage !== update.data.new.stage) {
//                                                                             title = `Stage changed from ${update.data.old.stage} to ${update.data.new.stage}`;
//                                                                             details = `Probability changed from ${update.data.old.probability}% to ${update.data.new.probability}%`;
//                                                                         } else if (!update.data.old.stage && update.data.new.stage) {
//                                                                             title = `Stage changed to ${update.data.new.stage}`;
//                                                                             details = `Probability set to ${update.data.new.probability}%`;
//                                                                         }
//                                                                     }
//                                                                 } else if (update.history_type === "lead") {
//                                                                     if (update.action === "Lead created by converting the lead") {
//                                                                         title = `${update.action} - ${update.data?.lead_name || 'Unknown Lead'}`;
//                                                                     }
//                                                                 }

//                                                                 return (
//                                                                     <div key={index} className="timeline-item">
//                                                                         <div className="timeline-time">
//                                                                             {moment(update.created_at).format("h:mm A")}
//                                                                         </div>

//                                                                         <div className="timeline-icon">{getIcon(update.action)}</div>

//                                                                         <div className="timeline-line"></div>

//                                                                         <div className="timeline-content">
//                                                                             <p className="timeline-title">{title}</p>
//                                                                             {details && <div className="timeline-details">{details}</div>}
//                                                                             <p className="timeline-byline">
//                                                                                 <small>by {update.created_by} {moment(update.created_at).format("MMM DD, YYYY")}</small>
//                                                                             </p>
//                                                                         </div>
//                                                                     </div>
//                                                                 );
//                                                             })}
//                                                     </div>
//                                                 ))}
//                                                 </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         ) : activeTab === "timeline" ? (
//                                             <p>Loading timeline...</p>
//                                         ) : null}

//                                     </div>

//                                 </div>
//                             </div>

//                         </div>


//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default LeadDetails;

import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Container, Card, Tabs, Tab, Button, Offcanvas, Badge } from 'react-bootstrap';
import { BiPencil } from "react-icons/bi";
import { BsX } from "react-icons/bs";
import {
    FaRegClock,
    FaUserEdit,
    FaFileInvoice,
    FaTag,
    FaAddressCard,
    FaBuilding,
    FaUser,
    FaStickyNote,
    FaArrowRight
} from "react-icons/fa";
import { useAuth } from '../../../context/AuthContext';

import moment from "moment";
import LeadView from './LeadView';
import SelectedContact from '../../contact/SelectedContact';
import withPermission from '../../../utils/withPermission';
import ActivityList from './activity/ActivityList';
import LeadModal from './LeadModal';
import LeadPermissions from './LeadPermissions';
const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
const WithActivityPermission = withPermission(({ children }) => children, ['activity-list']);

const LeadDetails = ({ show, onHide, leadId }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialTab = queryParams.get("activeTab") || "activityList";
    const [leadDetails, setLeadDetails] = useState(null);
    const [activeTab, setActiveTab] = useState('activityList');
    const [activities, setActivities] = useState([]); // Added activities state

    const [showModal, setShowModal] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [timelineUpdates, setTimelineUpdates] = useState([]);
    const [leads, setLead] = useState(null);
    const [contacts, setContacts] = useState([]);
    const [organisations, setOrganisation] = useState([]);
    const [reopenOffcanvas, setReopenOffcanvas] = useState(false);

    const didFetchRef = useRef(false);
    const [localShow, setLocalShow] = useState(show);
    const [isMinimizing, setIsMinimizing] = useState(false);
    const { roles, dataScopes } = useAuth();
    const isAllowedToReassign = roles?.some(role => role.toLowerCase() === 'superadmin') ||
        dataScopes?.some(scope => scope === 'all' || scope === 'team');

    // Sync with parent show prop
    useEffect(() => {
        if (!isMinimizing) {
            setLocalShow(show);
        }
    }, [show, isMinimizing]);
    const fetchTimelineUpdates = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let params = {};
            params.lead_id = leadId || id;

            if (!params.lead_id) {
                console.warn("Missing lead_id, skipping API call.");
                return;
            }

            const response = await axios.get(`${backendUrl}/api/history/all`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params,
                skipLoader: true,

            });

            setTimelineUpdates(response.data.data);
        } catch (error) {
            console.error("Error fetching timeline updates:", error);
        }
    };

    const fetchLeadDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const currentId = leadId || id;
            const response = await axios.get(`${backendUrl}/api/leads/${currentId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            setLeadDetails(response.data.Data);
        } catch (error) {
            console.error('Error fetching lead details:', error);
        }
    };

    // Add function to fetch activities
    const fetchActivities = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/activities`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    lead_id: leadId || id,
                },
                skipLoader: true,

            });

            setActivities(response.data.data?.data || []);
        } catch (error) {
            console.error('Error fetching activities:', error);
        }
    };

    const fetchContacts = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contact`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const filteredContacts = response.data.Data.filter(
                contact => contact.type !== "instance" && contact.type !== "tenant"
            );

            setContacts(filteredContacts);
        } catch (error) {
            console.error('Error fetching contacts:', error);
        }
    };

    const fetchOrganisation = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/organisation`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            setOrganisation(response.data.data);
        } catch (error) {
            console.error(`Error fetching organisations:`, error);
        }
    };

    const editLead = async (contactId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/leads/${contactId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const updatedLead = response.data.Data;

            if (updatedLead) {
                setLeadDetails((prevLead) => ({
                    ...prevLead,
                    ...updatedLead,
                }));

                setLead((prevOrganisations) =>
                    prevOrganisations
                        ? prevOrganisations.map((org) =>
                            org.id === updatedLead.id ? updatedLead : org
                        )
                        : [updatedLead]
                );
            }

            setShowModal(false);
            if (reopenOffcanvas) {
                setReopenOffcanvas(false);
                // Delay slightly to avoid rendering issues
                setTimeout(() => {
                    onHide(false); // ensure offcanvas reopens
                    // Or call a function to reopen with updated lead
                }, 100);
            }
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            } else {
                console.error(`Error updating lead:`, error);
            }
        }
    };

    // useEffect(() => {
    //     if (show) {
    //         fetchLeadDetails();
    //         fetchActivities(); // Fetch activities when component shows
    //     }
    // }, [show, leadId]);
    useEffect(() => {
        if (localShow && leadId) {
            setLeadDetails(null); // Clear previous data
            fetchLeadDetails();
            fetchActivities();
        }
    }, [localShow, leadId]);

    useEffect(() => {
        if (localShow && activeTab === 'timeline') {
            fetchTimelineUpdates();
        }
    }, [localShow, activeTab]);

    // const handleOffcanvasClose = () => {
    //     setLocalShow(false);
    //     // Don't reset leadDetails here - let the parent handle the hide
    //     onHide(); // Notify parent
    // };

    //     useEffect(() => {
    //         if (show && activeTab === 'timeline') {
    //             fetchTimelineUpdates();
    //         }
    //     }, [show, activeTab]);


    const handleOffcanvasClose = () => {
        if (isMinimizing) return;
        setLeadDetails(null);
        setActiveTab('activityList');
        didFetchRef.current = false;
        onHide();
    };
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const getIcon = (action) => {
        switch (action) {
            case "Lead Created":
                return <div className="timeline-icon-circle bg-success"><FaRegClock className="text-white" size={12} /></div>;
            case "Lead Updated":
                return <div className="timeline-icon-circle bg-primary"><FaUserEdit className="text-white" size={12} /></div>;
            case "Contact Added":
                return <div className="timeline-icon-circle bg-info"><FaAddressCard className="text-white" size={12} /></div>;
            case "status":
                return <div className="timeline-icon-circle bg-warning"><FaTag className="text-white" size={12} /></div>;
            default:
                return <div className="timeline-icon-circle bg-secondary"><FaRegClock className="text-white" size={12} /></div>;
        }
    };

    const groupByDate = (updates) => {
        return updates.reduce((grouped, update) => {
            const date = moment(update.created_at).format("MMM DD, YYYY");
            if (!grouped[date]) {
                grouped[date] = [];
            }
            grouped[date].push(update);
            return grouped;
        }, {});
    };

    const groupedUpdates = groupByDate(timelineUpdates);
    const [showModalAfterClose, setShowModalAfterClose] = useState(false);
    const [modalLeadData, setModalLeadData] = useState(null);
    const [closeOffcanvas, setCloseOffcanvas] = useState(false);

    return (
        <>
            <Offcanvas
                show={localShow}
                onHide={handleOffcanvasClose}
                placement="end"
                style={{
                    width: '1080px',
                    ...(isMinimizing ? { visibility: 'hidden', opacity: 0, pointerEvents: 'none' } : {})
                }}
                backdropClassName={isMinimizing ? 'd-none' : ''}
                className={`lead-offcanvas ${isMinimizing ? 'minimized' : ''}`}
                enforceFocus={false}
                autoFocus={false}
                restoreFocus={false}
                unmountOnExit={false}
            >

                {/* Offcanvas Header */}
                <Offcanvas.Header className="border-bottom bg-white py-3">
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center">
                            <div className="bg-primary rounded-circle p-2 me-3">
                                <FaUser className="text-white" size={18} />
                            </div>
                            <div>
                                <h5 className="mb-0 fw-bold text-dark">{leadDetails?.name}</h5>
                                {/* <small className="text-muted">Lead ID: {leadId || id}</small> */}
                            </div>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => {
                                    // Then open the edit modal
                                    setSelectedLead(leadDetails);
                                    setIsMinimizing(true);
                                    setShowModal(true);
                                    // setLocalShow(false); // Keep open but minimized
                                }}
                            >
                                <BiPencil className="me-1" />
                                Edit Lead
                            </Button>



                            <Button
                                variant="light"
                                size="sm"
                                onClick={handleOffcanvasClose}
                                className="border-0"
                            >
                                <BsX size={20} />
                            </Button>
                        </div>
                    </div>
                </Offcanvas.Header>

                {/* Offcanvas Body */}
                <Offcanvas.Body className="p-0">
                    {/* Lead Summary Card */}
                    <div className="p-4 border-bottom bg-light">
                        <div className="row g-4">
                            <div className="col-md-6">
                                <div className="d-flex align-items-center">
                                    <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                        <FaBuilding className="text-primary" size={16} />
                                    </div>
                                    <div>
                                        <label className="text-muted small mb-1 d-block">Organisation</label>
                                        <h6 className="mb-0 fw-semibold text-dark">
                                            {leadDetails?.organisation?.name || 'Not assigned'}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex align-items-center">
                                    <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                        <FaTag className="text-primary" size={16} />
                                    </div>
                                    <div>
                                        <label className="text-muted small mb-1 d-block">Lead Source</label>
                                        <h6 className="mb-0 fw-semibold text-dark text-capitalize">
                                            {leadDetails?.lead_source ? leadDetails.lead_source.replace('_', ' ') : 'Not specified'}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-flex align-items-start">
                                    <div className="bg-white rounded-circle p-2 shadow-sm me-3 mt-1">
                                        <FaStickyNote className="text-primary" size={16} />
                                    </div>
                                    <div className="flex-grow-1">
                                        <label className="text-muted small mb-1 d-block">Notes</label>
                                        <div className="bg-white p-3 rounded border">
                                            <p className="mb-0 text-dark">
                                                {leadDetails?.notes || 'No notes available for this lead.'}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Navigation Tabs */}
                    <div className="border-bottom bg-white">
                        <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                            <WithActivityPermission>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'activityList' ? 'active' : ''}`}
                                        onClick={() => handleTabClick('activityList')}
                                        role="tab"
                                    >
                                        <FaRegClock className="me-2" size={14} />
                                        Activities
                                        {activities.length > 0 && (
                                            <span className="badge bg-primary ms-2">{activities.length}</span>
                                        )}
                                    </button>
                                </li>
                            </WithActivityPermission>
                            <WithContactPermission>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
                                        onClick={() => handleTabClick('contactList')}
                                        role="tab"
                                    >
                                        <FaUser className="me-2" size={14} />
                                        Contacts
                                    </button>
                                </li>
                            </WithContactPermission>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'leadDetails' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('leadDetails')}
                                    role="tab"
                                >
                                    <FaBuilding className="me-2" size={14} />
                                    Details
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'timeline' ? 'active' : ''}`}
                                    onClick={() => {
                                        handleTabClick('timeline');
                                        fetchTimelineUpdates();
                                    }}
                                    role="tab"
                                >
                                    <FaRegClock className="me-2" size={14} />
                                    Timeline
                                    {timelineUpdates.length > 0 && (
                                        <span className="badge bg-primary ms-2">{timelineUpdates.length}</span>
                                    )}
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'permissions' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('permissions')}
                                    role="tab"
                                >
                                    <FaUser className="me-2" size={14} />
                                    Assign
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Tab Content */}
                    <div className="tab-content p-4 bg-white" style={{ minHeight: '500px', maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
                        {/* Contact List Tab */}
                        {activeTab === "contactList" && leadDetails && (
                            <div className="tab-pane active">
                                <SelectedContact
                                    leadId={leadDetails?.id}
                                    entityType="lead"
                                    fetchLeadData={fetchLeadDetails}
                                    leadData={leadDetails}
                                    setLeadDetails={setLeadDetails}
                                    onCloseOffcanvas={() => {
                                        setIsMinimizing(true);
                                        // setLocalShow(false);
                                    }}
                                    onReopenOffcanvas={() => {
                                        setIsMinimizing(false);
                                        // setLocalShow(true);
                                    }}
                                />
                            </div>
                        )}

                        {/* Activity List Tab */}
                        {activeTab === "activityList" && leadDetails && (
                            <div className="tab-pane active">
                                <ActivityList
                                    leadId={leadDetails?.id}
                                    type='lead'
                                    fetchLeadData={fetchLeadDetails}
                                    leadData={leadDetails}
                                    setLeadDetails={setLeadDetails}
                                    onModalShow={() => {
                                        setIsMinimizing(true);
                                        // setLocalShow(false);
                                    }}
                                    onModalClose={() => {
                                        setIsMinimizing(false);
                                        // setLocalShow(true);
                                    }}
                                />
                            </div>
                        )}

                        {/* Lead Details Tab */}
                        {activeTab === "leadDetails" && (
                            <div className="tab-pane active">
                                {leadDetails ? (
                                    <LeadView
                                        data={leadDetails}
                                        leadId={leadId || id}
                                        setLeadDetails={setLeadDetails}
                                    />
                                ) : (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-2 text-muted">Loading lead details...</p>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Timeline Tab */}
                        {activeTab === "timeline" && leadDetails && (
                            <div className="tab-pane active">
                                {timelineUpdates.length > 0 ? (
                                    <div className="timeline-vertical">
                                        {Object.entries(groupedUpdates ?? {})
                                            .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA))
                                            .map(([date, updates]) => (
                                                <div key={date} className="timeline-date-section mb-4">
                                                    <div className="timeline-date-header bg-light px-3 py-2 rounded mb-3">
                                                        <span className="fw-semibold text-dark">{date}</span>
                                                        <span className="badge bg-primary ms-2">{updates.length}</span>
                                                    </div>

                                                    <div className="timeline-events">
                                                        {updates
                                                            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                                                            .map((update, index) => {
                                                                let title = update.action;
                                                                let details = null;
                                                                let icon = null;

                                                                const formatFieldName = (field) => {
                                                                    return field.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
                                                                };

                                                                if (update.history_type === "activity") {
                                                                    if (update.action === "Meeting added" || update.action === "Task added" || update.action === "Call added") {
                                                                        title = `${update.action} - ${update.data.subject}`;
                                                                        icon = getIcon(update.action);
                                                                    } else if (update.action === "Meeting updated" || update.action === "Task updated" || update.action === "Call updated") {
                                                                        title = `${update.action}`;
                                                                        icon = getIcon(update.action);
                                                                        if (update.data.changes) {
                                                                            details = Object.entries(update.data.changes)
                                                                                .filter(([key]) => !["created_at", "updated_at", "lead"].includes(key))
                                                                                .map(([key, change]) => (
                                                                                    <div key={key} className="timeline-change-item">
                                                                                        <span className="text-muted">{formatFieldName(key)}:</span>
                                                                                        <span className="text-danger mx-1">{change.old}</span>
                                                                                        <FaArrowRight className="text-muted mx-1" size={10} />
                                                                                        <span className="text-success mx-1">{change.new}</span>
                                                                                    </div>
                                                                                ));
                                                                        }
                                                                    }
                                                                } else if (update.history_type === "lead") {
                                                                    if (update.action === "Lead Updated" && update.data.old && update.data.new) {
                                                                        if (update.data.old.stage && update.data.new.stage && update.data.old.stage !== update.data.new.stage) {
                                                                            title = `Stage Updated`;
                                                                            details = (
                                                                                <div className="timeline-stage-change">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <span className="badge bg-light text-dark me-2">{update.data.old.stage}</span>
                                                                                        <FaArrowRight className="text-muted mx-2" size={12} />
                                                                                        <span className="badge bg-primary">{update.data.new.stage}</span>
                                                                                    </div>
                                                                                    <div className="text-muted small mt-1">
                                                                                        Probability: {update.data.old.probability}% → {update.data.new.probability}%
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                            icon = getIcon("status");
                                                                        } else if (!update.data.old.stage && update.data.new.stage) {
                                                                            title = `Stage Set`;
                                                                            details = `Stage set to ${update.data.new.stage} with ${update.data.new.probability}% probability`;
                                                                            icon = getIcon("status");
                                                                        }
                                                                    } else if (update.action === "Lead created by converting the lead") {
                                                                        title = `Lead Converted`;
                                                                        details = `Converted to ${update.data?.lead_name || 'Unknown Lead'}`;
                                                                        icon = getIcon("Lead Created");
                                                                    } else {
                                                                        icon = getIcon(update.action);
                                                                    }
                                                                }

                                                                return (
                                                                    <div key={index} className="timeline-item mb-3">
                                                                        <div className="d-flex">
                                                                            <div className="timeline-icon-container me-3">
                                                                                {icon || getIcon(update.action)}
                                                                            </div>
                                                                            <div className="timeline-content flex-grow-1">
                                                                                <div className="bg-light rounded p-3">
                                                                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                                                                        <h6 className="mb-0 fw-semibold text-dark">{title}</h6>
                                                                                        <small className="text-muted bg-white px-2 py-1 rounded">
                                                                                            {moment(update.created_at).format("h:mm A")}
                                                                                        </small>
                                                                                    </div>
                                                                                    {details && (
                                                                                        <div className="timeline-details mt-2">
                                                                                            {details}
                                                                                        </div>
                                                                                    )}
                                                                                    <div className="timeline-meta mt-2 pt-2 border-top">
                                                                                        <small className="text-muted">
                                                                                            <FaUser className="me-1" size={12} />
                                                                                            {update.created_by}
                                                                                        </small>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                ) : (
                                    <div className="text-center py-5">
                                        <div className="bg-light rounded p-5">
                                            <FaRegClock className="text-muted mb-3" size={32} />
                                            <h6 className="text-muted">No Timeline Activity</h6>
                                            <p className="text-muted small mb-0">
                                                There's no activity recorded in the timeline yet.
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        {/* Permissions Tab */}
                        {activeTab === "permissions" && leadDetails && (
                            <div className="tab-pane active">
                                <LeadPermissions
                                    leadId={leadDetails?.id}
                                    leadData={leadDetails}
                                    fetchLeadDetails={fetchLeadDetails}
                                />
                            </div>
                        )}
                    </div>
                </Offcanvas.Body>


            </Offcanvas>

            {/* Lead Modal */}
            {showModal && (
                <LeadModal
                    showModal={showModal}
                    handleClose={() => {
                        setShowModal(false);
                        setIsMinimizing(false);
                        setLocalShow(true);
                    }}
                    leadData={selectedLead}
                    editLead={editLead}
                    fetchOrganisation={fetchOrganisation}
                    fetchContacts={fetchContacts}
                    contacts={contacts}
                    organisations={organisations}
                    leadId={leadId || id}
                />
            )}
        </>
    );
};

export default LeadDetails;
